import { useQuery } from 'react-query';
import { OneIdEnvironment, useOneIdEnvironment } from './useOneIdEnvironment';
import { fetchWrapper } from '../utils';
type RevenueProfileResponse = {
  profVal: string;
};
const fetchRevenueData =
  ({ revenuePrefix }: OneIdEnvironment, profileName) =>
  async () => {
    const { profVal } = await fetchWrapper<RevenueProfileResponse>(
      `${revenuePrefix}/api/revpro/secure/gVar/profileValue?profile_name=${profileName}`,
    );
    return profVal;
  };
export const useRevenueProfiles = (profileName, enabled) => {
  const environment = useOneIdEnvironment();
  return useQuery({
    queryKey: ['Revenue Profiles', profileName],
    queryFn: fetchRevenueData(environment, profileName),
    enabled: enabled,
    cacheTime: 0,
  });
};
